import { TeContainer } from '@topcon/tuicl-react';

import { EulaView } from '../../Eula';

interface ReviewAgreementStepProps {
  onChecked: (checked: boolean) => void;
}

function ReviewAgreementStep({ onChecked }: ReviewAgreementStepProps) {
  return (
    <TeContainer
      column
      grow
      backgroundColor="background.secondary"
      overflow="auto"
      justifyContent="center"
      borderRadius="l"
      padding={0}
    >
      <EulaView onChecked={onChecked} />
    </TeContainer>
  );
}

export default ReviewAgreementStep;
